"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const Tooltip_1 = require("~/components/UI/Tooltip");
const utils_1 = require("~/utils/utils");
const PriceTooltip_scss_1 = __importDefault(require("./PriceTooltip.scss"));
function PriceTooltip({ price, unitOfMeasurement }) {
    return (react_1.default.createElement(Tooltip_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: PriceTooltip_scss_1.default.tooltip },
            (0, utils_1.formatCurrency)(price),
            " / ",
            unitOfMeasurement) },
        react_1.default.createElement("img", { className: PriceTooltip_scss_1.default['price-icon'], src: assets_1.svgQuoteListItemPrice, alt: "" })));
}
exports.default = PriceTooltip;
